/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { selectLogin } from '../../../../store/login/loginSlice';
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { CustomGrid, CustomInfosForm } from '../../../../assets/style/globalStyle';
import { Stack, Typography, Button, Card, Grid, TextField, Box } from '@mui/material';
import { isMobile } from 'react-device-detect';

import configAxios from '../../../../services/configAxios';
import RenderPage from '../../../layouts/RenderPage';
import Iconify from '../../../../@core/theme/Iconify';
import BreadcrumbsNav from '../../../components/multiplesComponents/BreadCrumbs';
import palette from 'src/@core/theme/palette';

const RepUsedTokens = (props) => {
  const [infosReport, setInfosReport] = useState([]);
  const infoStateTemp = useSelector(selectLogin);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });

  function HandleInputChange(event, broker, vend) {
    setInfosReport({
      ...infosReport,
      [event.target.name]: event.target.value,
      id: infoState.id_establishment
    });
  }

  function HandleExport() {
    if (!infosReport.datainicial || !infosReport.datafim) {
      NotificationManager.warning('Por favor, preencha todos os campos obrigatórios!', 'Atenção');
      return;
    }

    const infosExport = {
      infosReport: infosReport
    };

    configAxios
      .post('/establishments/reportUsedTokensReportPdf', infosExport, { responseType: 'blob' })
      .then((response) => {
        if (response.status === 202) {
          NotificationManager.warning(
            'Não encontramos informações para os parâmetros selecionados!',
            'Atenção'
          );
          return;
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Relatório de tokens.pdf');
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para gerar o relatório! Por favor, tente novamente!',
          'Atenção'
        );
      });
  }

  function ClearInputs() {
    setInfosReport([]);
  }

  return (
    <RenderPage title="Relatórios">
      <Stack direction="row" alignItems="center" justifyContent="start" mb={2}>
        <Grid container>
          <BreadcrumbsNav {...props} />
          <Grid item xs={12} sx={{ mt: 2 }}>
            <Typography variant="h4" gutterBottom>
              Relatório de vendas
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2" gutterBottom>
              Utilize as opções abaixo para filtrar o relatório de tokens
            </Typography>
          </Grid>
        </Grid>
        <Stack direction="row" alignItems="center" justifyContent="end" mb={2}>
          {!isMobile && (
            <>
              <Button
                variant="outlined"
                onClick={ClearInputs}
                sx={{ ml: 1, mr: 1 }}
                startIcon={<Iconify icon="eva:refresh-outline" />}>
                Limpar
              </Button>
              <Button
                variant="outlined"
                color="error"
                component={RouterLink}
                to="/app/dashboard"
                startIcon={<Iconify icon="eva:arrow-back-fill" />}>
                Voltar
              </Button>
            </>
          )}
        </Stack>
      </Stack>
      <Card>
        <CustomGrid>
          <Box sx={{ width: '100%', mt: 1, border: 1, borderColor: 'grey.200', p: 2 }}>
            <CustomInfosForm style={{ color: palette.primary.contrastText }}>
              Campos obrigatórios possuem asterisco (*)
            </CustomInfosForm>
            <Grid
              container
              spacing={2}
              sx={{ mt: 2, input: { color: palette.primary.contrastText } }}>
              <Grid item xs={12} md={4}>
                <TextField
                  name="datainicial"
                  fullWidth
                  label="Data inicial"
                  variant="outlined"
                  required
                  size="small"
                  type="date"
                  value={infosReport.datainicial || ''}
                  onChange={(event) => HandleInputChange(event)}
                  style={{ color: palette.primary.contrastText }}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  name="datafim"
                  fullWidth
                  label="Data final"
                  variant="outlined"
                  required
                  size="small"
                  type="date"
                  value={infosReport.datafim || ''}
                  style={{ color: palette.primary.contrastText }}
                  onChange={(event) => HandleInputChange(event)}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
            </Grid>
          </Box>
          <Stack direction="row" justifyContent="end" sx={{ mt: 5 }}>
            <div>
              <Button
                type="submit"
                variant="contained"
                size="medium"
                color="success"
                sx={{ mr: 2, textTransform: 'none' }}
                onClick={HandleExport}
                startIcon={<Iconify icon="eva:file-text-outline" />}>
                Exportar em pdf
              </Button>
            </div>
            <Button
              variant="contained"
              color="error"
              component={RouterLink}
              to="/app/dashboard"
              startIcon={<Iconify icon="eva:close-circle-fill" />}>
              Cancelar
            </Button>
          </Stack>
        </CustomGrid>
      </Card>
    </RenderPage>
  );
};

export default RepUsedTokens;
